<template>
  <div class="content">
    <!--    <img v-show="$i18n.locale==='zh'" src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title.png"  class='img-title'>-->
    <!--    <img v-show="$i18n.locale==='en'" :src="home_title_en"  class='img-title-en'>-->
    <el-row style="margin-top:3vw">
      <el-col :lg="24">
        <div >
          <div class='home_title' id="game">
            <h1 style="text-align: center;margin-top: 0px;color: black;">OUR GAMES</h1>
          </div>
          <div class="container-ourgame">
            <el-element class="item"> <img src="../assets/img_grande/game4.png" alt="">
            </el-element>
            <el-element class="item"> <img src="../assets/img_grande/game5.png" alt="">
            </el-element>
            <el-element class="item"> <img src="../assets/img_grande/game1.png" alt="">
            </el-element>
            <el-element class="item"> <img src="../assets/img_grande/game2.png" alt="">
            </el-element>
            <el-element class="item"> <img src="../assets/img_grande/game3.png" alt="">
            </el-element>
          </div>
          <div class='home_title' id="about">
            <h1 style="text-align: center;margin-top: 20px;color: black;">ABOUT US</h1>
          </div>
          <div class="container-ourgame">
<!--            <el-element class="item"> <img src="../assets/images_new/new_about4.png" alt="">-->
<!--            </el-element>-->
            <span class="hidden-sm-and-down" style="text-align: left;font-size: 40px;margin-top: 10px; width: 90vw;">
              MIG INTERACTIVE is an internet company specializing in game development and operations, founded in 2019 and headquartered in Hongkong.<br><br>
              Its business scope includes the development and publishing of casual and mid-to-hardcore games.<br><br>
              Adhering to the philosophy of "user-centric,product-driven,and market-first<br><br>
              MIG INTERACTIVE is committed to providing high-quality localized games to players worldwide, aiming to become a leading global mobile game company<br><br>
              The company will continue to increase investment in research and development, launching more premium games.<br><br>
              Its current operational regions include the Middle East, South America, and South Asia.<br><br>
            </span>
            <span class="hidden-sm-and-up" style="text-align: left;font-size: 20px;margin-top: 10px; width: 90vw;">
              MIG INTERACTIVE is an internet company specializing in game development and operations, founded in 2019 and headquartered in Hongkong.<br><br>
              Its business scope includes the development and publishing of casual and mid-to-hardcore games.<br><br>
              Adhering to the philosophy of "user-centric,product-driven,and market-first<br><br>
              MIG INTERACTIVE is committed to providing high-quality localized games to players worldwide, aiming to become a leading global mobile game company<br><br>
              The company will continue to increase investment in research and development, launching more premium games.<br><br>
              Its current operational regions include the Middle East, South America, and South Asia.<br><br>
            </span>
          </div>

          <div class='home_title' id="connect">
            <h1 style="text-align: center;margin-top: 20px;margin-bottom:40px;color: black;">JOIN US</h1>
          </div>
          <div class='home_content' style="width: 1000px;">
            <el-carousel :interval="4500" type="card" :width="clientHeight" :autoplay="true"
                         class="carou-height hidden-sm-and-down">
              <el-carousel-item v-for="item in bole_images" :key="item.name" :style="item.style">
                <!--              <div class="photo-title"><span class="photo-span"></span></div>-->
              </el-carousel-item>
            </el-carousel>
          </div>
          <el-carousel :interval="4500" type="card" :height="clientHeight2" :autoplay="true"
                       class="carou-height hidden-md-and-up">
            <el-carousel-item v-for="item in bole_images" :key="item.name" :style="item.style">
              <!--              <div class="photo-title"><span class="photo-span"></span></div>-->
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
    </el-row>
  </div>

</template>

<script>
export default {

  data() {
    return {
      all_news: [],
      clientHeight: `${document.documentElement.clientWidth * (4016 / 6016)}px`,
      clientHeight2: `${document.documentElement.clientWidth * (545 / 1920)}px`,

      bole_images: [
        {
          name: 'photo1',
          style: {
            backgroundImage: `url('${require('../assets/home/photo_1.png')}')`,
            backgroundSize: '100% ',
            'background-repeat': 'no-repeat',
            backgroundColor: '#0a0726',

          },
        },
        {
          name: 'photo2',
          style: {
            backgroundImage: `url('${require('../assets/home/photo_2.png')}')`,
            backgroundSize: '100% ',
            'background-repeat': 'no-repeat',
            backgroundColor: '#0a0726',
          },
        },
        {
          name: 'photo3',
          style: {
            backgroundImage: `url('${require('../assets/home/photo_3.png')}')`,
            backgroundSize: '100% ',
            'background-repeat': 'no-repeat',
            backgroundColor: '#0a0726',

          },
        },
      ]
    };
  },

  mounted() {
    const that = this;
    window.onresize = function temp() {
      that.clientWidth = `${document.documentElement.clientHeight}px`;
    };
  },
  methods: {
    // test() {
    //   const jsonUrl = './api/upload_emails';
    //   this.axios.get(jsonUrl)
    //     .then((res) => {
    //       console.log(res)
    //     });
    // }
  },
  computed: {
    //是否使用移动端视频
    is_mobile_video() {
      return document.documentElement.clientWidth > 992;
    },
    home_title_en() {
      return document.documentElement.clientWidth > 992 ? 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_en.png' : 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_en_mobile.png';
    }
  },
};
</script>

<style lang='less'>
@import 'element-ui/lib/theme-chalk/display.css';
@import url('../assets/style/common.less');
@import url('../assets/style/colors.less');

.content {
  width: 100%;
  margin: 0 auto;
  padding-top: 3%;
}

.content-en-mobile {
  display: none;
}

.img-title {
  height: 4.5vw;
  margin-bottom: 0.5vw
}

.img-title-en {
  height: 7.5vw;
  margin-bottom: 0.5vw
}

.home-title-icon {
  height: 4.5vw;
}

.photo-title {
  position: absolute;
  width: 100%;
  bottom: 0;
  background: @lanmu;
  height: 45px;
  font-size: 18px;
  line-height: 43px;
  color: #f3c258;
  border-bottom: 4px solid #f3c258;

  span.photo-span {
    border-bottom: 1px solid;
  }
}

.carou-height {
  overflow: hidden;
}

@media screen and (max-width: 992px) {
  .content-en-mobile {
    display: block;
    margin: 5vw 0 10vw 0;
  }

  .img-title {
    height: 5.5vw;
    margin-bottom: 0.5vw;
  }

  .img-title-en {
    height: 11.5vw;
    margin-top: 5vw;
    margin-bottom: 0.5vw;
  }

  .home-title-icon {
    height: 6.5vw;
  }

  .photo-title {
    height: 32px;
    font-size: 14px;
    line-height: 30px;
    color: #f3c258;
    border-bottom: 3px solid #f3c258;

    span.photo-span {
      border-bottom: 1px solid;
    }
  }
}

//给轮播图选项页增加固定高度，避免抖动
.el-carousel__indicators--outside {
  height: 4vw;
}
.news {
  list-style-type: None;

  .image {
    width: 100%;
    display: block;
  }

  a {
    text-decoration: none;
  }

  .content {
    width: 100%;
    height: 100px;
    background-size: cover;
  }
}
.el-carousel__item{
  border-radius: 20px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}


.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}


.container-ourgame {
  display: flex;
  /* 开启 flex 布局 */
  flex-direction: column;
  /* 元素从上到下排列 */
  justify-content: center;
  /* 垂直方向（纵向）居中 */
  align-items: center;
  /* 水平方向（横向）居中 */
  // height: 100vh;
}

.container-ourgame .item {
  padding: 10px 20px;
  color: white;
  margin: 5px 0;
  border-radius: 10px;
}

.container-ourgame img {
  width: 90vw;
  border-radius: 10px;
}

</style>




// WEBPACK FOOTER //
// src/components/Content.vue
